import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import {
	indexCentralInvoiceRecipientByClient,
	indexCentralInvoiceRecipients,
} from "~/modules/billing/api/centralInvoiceRecipient/centralInvoiceRecipientApiDispatchers.ts";

export const centralInvoiceRecipientQueries = {
	baseKey: ["invoice-recipient"],
	all: () => queryOptions({
		queryKey: [...centralInvoiceRecipientQueries.baseKey, "all"],
		queryFn: () => indexCentralInvoiceRecipients().then(getDataFromResponse),
	}),
	byClient: (clientId: string) =>
		queryOptions({
			queryKey: [...centralInvoiceRecipientQueries.baseKey, "client", clientId],
			queryFn: () => indexCentralInvoiceRecipientByClient(clientId).then(getDataFromResponse),
			enabled: !!clientId,
		}),
};